import React, { FC } from "react";
import { useIntl } from "react-intl";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { SelectControl } from "./SelectControl";
import { TimePickerControl } from "./TimePickerControl";
import { messages } from "./SubscriptionsSettingsSchedule.messages";
import { ISubscriptionsSettingsScheduleProps } from "./SubscriptionsSettingsSchedule.types";
import { useStyles } from "./SubscriptionsSettingsSchedule.styles";
import {
  FrequencyOptions,
  DefaultSchedule,
  DefaultScheduleFrequency,
  DaysOfWeekOptions,
  DaysOptions,
  MonthsOfHalfYearOptions,
  MonthsOfQuarterOptions,
  MonthsOptions,
} from "./SubscriptionsSettingsSchedule.constants";
import { SchedulerFrequency } from "../../../types";

export const SubscriptionsSettingsSchedule: FC<ISubscriptionsSettingsScheduleProps> = (props) => {
  const { value = DefaultSchedule, onChange } = props;
  const { formatMessage } = useIntl();
  const classes = useStyles();

  const daysOfMonthAnnuality = Array(new Date(new Date().getFullYear(), value.month || 1, 0).getDate() || 0)
    .fill(1)
    .map((_, i) => i + 1)
    .map((id) => ({ id, name: String(id) }));

  const handleFrequencyChange = (ev: React.ChangeEvent<HTMLInputElement>, freq: string) => {
    onChange(DefaultScheduleFrequency[Number(freq)]);
  };
  const handleTimeChange = (time: string) => {
    onChange({
      ...value,
      time,
    });
  };
  const handleDayChange = (day: number) => {
    if (value.frequency === SchedulerFrequency.Dayly) {
      return;
    }

    onChange({
      ...value,
      day,
    });
  };

  const handleMonthChange = (month: number) => {
    if (
      value.frequency === SchedulerFrequency.Dayly ||
      value.frequency === SchedulerFrequency.Weekly ||
      value.frequency === SchedulerFrequency.Monthly
    ) {
      return;
    }

    onChange({
      ...value,
      month,
      day: 1,
    });
  };

  return (
    <div className={classes.root}>
      <RadioGroup
        className={classes.frequencyOptions}
        aria-label="position"
        name="position"
        value={value.frequency}
        onChange={handleFrequencyChange}
      >
        {FrequencyOptions.map((freq) => (
          <FormControlLabel
            key={freq.id}
            className={classes.frequencyOptionLabel}
            value={freq.id}
            control={<Radio color="primary" className={classes.frequencyOptionControl} />}
            label={formatMessage(freq.name)}
          />
        ))}
      </RadioGroup>
      <div className={classes.controls}>
        {value.frequency === SchedulerFrequency.Quarterly && (
          <SelectControl
            label={messages.controlMonthOfQuarter}
            value={value.month}
            items={MonthsOfQuarterOptions}
            onChange={handleMonthChange}
          />
        )}
        {value.frequency === SchedulerFrequency.SemiAnnuality && (
          <SelectControl
            label={messages.controlMonthOfHalfYear}
            value={value.month}
            items={MonthsOfHalfYearOptions}
            onChange={handleMonthChange}
          />
        )}
        {value.frequency === SchedulerFrequency.Annuality && (
          <SelectControl label={messages.controlMonth} value={value.month} items={MonthsOptions} onChange={handleMonthChange} />
        )}

        {value.frequency === SchedulerFrequency.Weekly && (
          <SelectControl label={messages.controlDayOfWeek} value={value.day} items={DaysOfWeekOptions} onChange={handleDayChange} />
        )}
        {(value.frequency === SchedulerFrequency.Monthly ||
          value.frequency === SchedulerFrequency.Quarterly ||
          value.frequency === SchedulerFrequency.SemiAnnuality) && (
          <SelectControl label={messages.controlDay} value={value.day} items={DaysOptions} onChange={handleDayChange} />
        )}
        {value.frequency === SchedulerFrequency.Annuality && (
          <SelectControl label={messages.controlDay} value={value.day} items={daysOfMonthAnnuality} onChange={handleDayChange} />
        )}
        <TimePickerControl label={messages.controlTime} value={value.time} onChange={handleTimeChange} />
      </div>
    </div>
  );
};
